import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { AsyncPipe } from '@angular/common';
import { Component, computed } from '@angular/core';
import { TimeCardSettings } from '@app/features/operating-picture/map-wall-display/models';
import { TranslatePipe } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { LocationWidgetCard } from '../../shared/location-widget-card';

@Component({
  selector: 'topo-location-time-card',
  imports: [TranslatePipe, AsyncPipe, CdkDragHandle],
  templateUrl: './location-time-card.component.html',
  styleUrl: './location-time-card.component.scss'
})
export class LocationTimeCardComponent extends LocationWidgetCard<TimeCardSettings> {
  locationDate = computed(() => {
    const { timezone, utcOffset } = this.location();
    const { timeFormat } = this.settings();

    const topOfMinute$ = this.timer.topOfMinute$;

    // format without meridiem for ui display
    const format = timeFormat.replace(' A', '');
    const hasMeridiem = timeFormat.indexOf(' A') !== -1;

    if (!Boolean(timezone) && !Boolean(utcOffset)) {
      return null;
    }

    const currentTime$ = topOfMinute$.pipe(map(now => (Boolean(timezone) ? now.tz(timezone) : now.utcOffset(utcOffset))));

    return {
      time$: currentTime$.pipe(map(now => now.format(format).trim())),
      meridiem$: currentTime$.pipe(map(now => (hasMeridiem ? now.format('A') : null)))
    };
  });
}
